"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _bluekeelAssets = _interopRequireDefault(require("@bit/bluekeel.assets.people"));

var _reactRouterDom = require("react-router-dom");

var _FooterCss = _interopRequireDefault(require("./Footer.css.js"));

var _radium = _interopRequireDefault(require("radium"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Footer = function Footer(_ref) {
  var domain = _ref.domain,
      logo = _ref.logo;

  var scrollToTop = function scrollToTop() {
    window.scrollTo(0, 0);
  };

  var LinkList = function LinkList() {
    return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      key: "footer-link-1",
      style: _FooterCss.default.link,
      to: "/privacy",
      rel: "noopener noreferrer",
      target: "_blank",
      onClick: scrollToTop
    }, "Privacy Policy"), /*#__PURE__*/_react.default.createElement("div", {
      className: "delimiter"
    }, "|"), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Link, {
      key: "footer-link-2",
      style: _FooterCss.default.link,
      to: "/terms",
      rel: "noopener noreferrer",
      target: "_blank",
      onClick: scrollToTop
    }, "Terms and Conditions"), /*#__PURE__*/_react.default.createElement("div", {
      className: "delimiter"
    }, "|"), /*#__PURE__*/_react.default.createElement("a", {
      key: "footer-link-3",
      style: _FooterCss.default.link,
      href: "http://submit.bk-opt-out.com/unsub/VdjOmOF3gcfQW6ONkarM6GoTTH2iRdeBfoo7y6zBPb6oQnuoqxx2l8KrwMbVnCxq"
    }, "Unsubscribe"), /*#__PURE__*/_react.default.createElement("div", {
      className: "delimiter"
    }, "|"), /*#__PURE__*/_react.default.createElement("a", {
      key: "footer-link-4",
      style: _FooterCss.default.link,
      href: "mailto:info@".concat(domain, ".com")
    }, "Contact Us"));
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    style: _FooterCss.default.mainContainer
  }, domain === 'UnitedStatesCredit' && /*#__PURE__*/_react.default.createElement("div", {
    style: _FooterCss.default.peopleContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: _bluekeelAssets.default,
    alt: "footer-people",
    style: _FooterCss.default.peopleImage
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: _FooterCss.default.contentContainer
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo,
    alt: "footer-logo",
    style: _FooterCss.default.logo
  })), /*#__PURE__*/_react.default.createElement("div", {
    style: _FooterCss.default.linkContainer
  }, /*#__PURE__*/_react.default.createElement(LinkList, null)), /*#__PURE__*/_react.default.createElement("div", {
    style: _FooterCss.default.messageContainer,
    key: "footer-message-1"
  }, "".concat(domain, " is an Internet property of BlueKeel LLC, an independent \n                third party marketing company that connects consumers with third party companies. \n                ").concat(domain, " does not itself provide credit lending services. ").concat(domain, " \n                is not affiliated with, and this website has not been approved by, any agency of the \n                Federal Government.")), /*#__PURE__*/_react.default.createElement("div", {
    style: _FooterCss.default.messageContainer,
    key: "footer-message-2"
  }, "\xA9 2020 ALL RIGHTS RESERVED"));
};

var _default = (0, _radium.default)(Footer);

exports.default = _default;

//# sourceMappingURL=Footer.jsx.map